export default __webpack_public_path__ + "static/media/bandroom-recent-gigs-play.b2e354ca.svg";